import { combineReducers } from 'redux';
import { useDispatch } from 'react-redux';
import app from './app';
/* @ts-ignore module is untyped */
import auth from './auth';
/* @ts-ignore module is untyped */
import notifications from 'ReduxMessenger/reducers/Notifications';
/* @ts-ignore module is untyped */
import storefront from './storefront';
import themeDetails from './themeDetails';
const rootReducer = combineReducers({
  app,
  auth,
  notifications,
  storefront,
  themeDetails
});
export function useAppDispatch() {
  return useDispatch();
}
export default rootReducer;